module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/41.b5ab4166.png";